// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3CpGm","error":"Textarea_error__2vV7f","readonly":"Textarea_readonly__2x3lU","disabled":"Textarea_disabled__2q_0q"};